import { useState, useEffect } from 'react'
import { getUserProfile } from '../../lib/userProfile'
import { PencilIcon } from '@heroicons/react/outline'
import { ProfileModal } from '../modals/ProfileModal'

interface Props {
  userId: string
  currentDisplayName?: string
  onProfileUpdate?: (newDisplayName: string, isLinked: boolean) => void
  compact?: boolean
}

export const DisplayNameInput = ({
  userId,
  currentDisplayName,
  onProfileUpdate,
  compact = false,
}: Props) => {
  const [displayName, setDisplayName] = useState(currentDisplayName || '')
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false)

  useEffect(() => {
    if (currentDisplayName) {
      setDisplayName(currentDisplayName)
    } else {
      // Load from Firebase if not provided
      getUserProfile(userId).then((profile) => {
        if (profile?.displayName) {
          setDisplayName(profile.displayName)
        }
      })
    }
  }, [userId, currentDisplayName])

  const handleProfileUpdate = (newDisplayName: string, isLinked: boolean) => {
    setDisplayName(newDisplayName)
    onProfileUpdate?.(newDisplayName, isLinked)
  }

  if (compact) {
    return (
      <>
        <div
          onClick={() => setIsProfileModalOpen(true)}
          className="flex items-center gap-2 px-3 py-2 border rounded-md text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
        >
          <span className="flex-1">
            {displayName || 'Kattints a profil szerkesztéséhez'}
          </span>
          <PencilIcon className="h-4 w-4 text-gray-400" />
        </div>

        <ProfileModal
          isOpen={isProfileModalOpen}
          handleClose={() => setIsProfileModalOpen(false)}
          userId={userId}
          currentDisplayName={displayName}
          onProfileUpdate={handleProfileUpdate}
        />
      </>
    )
  }

  return (
    <>
      <div className="pb-4 pt-2 border-b border-gray-200 dark:border-gray-600">
        <p className="text-gray-500 dark:text-slate-200 pb-2 text-sm">
          Neved a ranglistán:
        </p>
        <div
          onClick={() => setIsProfileModalOpen(true)}
          className="flex items-center gap-2 px-3 py-2 border rounded-md text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
        >
          <span className="flex-1">
            {displayName || 'Kattints a profil szerkesztéséhez'}
          </span>
          <PencilIcon className="h-4 w-4 text-gray-400" />
        </div>
      </div>

      <ProfileModal
        isOpen={isProfileModalOpen}
        handleClose={() => setIsProfileModalOpen(false)}
        userId={userId}
        currentDisplayName={displayName}
        onProfileUpdate={handleProfileUpdate}
      />
    </>
  )
}
